import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/home";
import Colleges from "./pages/colleges";
import './app.css';
import CompareColleges from "./pages/comparecolleges";
import CollegeDetail from "./pages/collegedetail";
import PrivacyPolicy from "./pages/privacypolicy";
import TermsAndCondition from "./pages/termsandcondition";
import Advertise from "./pages/advertise";
import CampusAmbassador from "./pages/campusambassador";
import NotFound from "./pages/notfound";
import ScholarshipPage from "./pages/scholarshippage";
import ScholarshipDetails from "./pages/scholarshipdetails";
import QuestionandAnswer from "./pages/questionandanswer";
import FootExams from "./pages/footexams";
import ExamLists from "./pages/exam-lists.jsx";
import ExamDetails from "./pages/exam-deatils.jsx";
import { usePageTracking } from "./hooks/usePageTracking";
import AboutUs from "./pages/aboutus.jsx";
import ContactUs from "./pages/contactus.jsx";

function RouteHandler() {
  const { slug } = useParams();

  if (slug?.startsWith("best-colleges-under-")) {
    return <Colleges />;
  }

  return <CollegeDetail />;
}

function AppRoutes() {
  usePageTracking();

  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/college_listing" element={<Colleges />} />
        <Route path="/college_comparison" element={<CompareColleges />} />
        <Route path="/:id/:slug" element={<RouteHandler />} />

        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-conditions" element={<TermsAndCondition />} />
        <Route path="/advertise" element={<Advertise />} />
        <Route path="/campus-ambassador" element={<CampusAmbassador />} />
        <Route path="/scholarship-index" element={<ScholarshipPage />} />
        <Route path="/question-answer" element={<QuestionandAnswer />} />
        <Route
          path="/:id/scholarship-details/:slug"
          element={<ScholarshipDetails />}
        />
        <Route path="/exam-index" element={<FootExams />} />
        <Route path="/exam-list" element={<ExamLists />} />
        <Route path="/:id/exam-details/:slug" element={<ExamDetails />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
